import { useLocation } from 'react-router';
import ReceiptTable from './ReceiptTable'
import PaymentTable from './PaymentTable'

export default function CombinePaymentReceipt() {
  const location = useLocation();
const { entry , voucher_type , comeBack} = location.state || {};
  return (
    <div className='flex gap-2 justify-between '>
    <div id="receipt-section">
          <ReceiptTable entryData={entry && (entry.voucher_type === "receipt" || voucher_type === "receipt") && entry} comeBack={comeBack} />
    </div>
    <div id="payment-section">
          <PaymentTable entryData={entry && (entry.voucher_type === "payment" || voucher_type === "payment") && entry} comeBack={comeBack} />
    </div>
      
    </div>
  )
}